/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

const isHoverMode = function () {
	return window.matchMedia(
		"(hover: hover) and (pointer: fine) and (min-width: 768px)",
	).matches;
};

document.addEventListener("DOMContentLoaded", function () {
	// Find all accordion containers
	const accordions = document.querySelectorAll(".accordion-container");

	accordions.forEach(function (accordion) {
		const items = accordion.querySelectorAll(".accordion-item");

		const openItem = function (targetItem) {
			requestAnimationFrame(function () {
				items.forEach(function (otherItem) {
					otherItem.classList.remove("is-open");
				});
				targetItem.classList.add("is-open");
			});
		};

		items.forEach(function (item) {
			const row = item.querySelector(".accordion-row");
			const content = item.querySelector(".accordion-content");
			const arrow = item.querySelector(".accordion-arrow");

			if (!row || !content || !arrow) return;

			row.style.cursor = "pointer";

			const toggleItem = function () {
				const isOpen = item.classList.contains("is-open");

				requestAnimationFrame(function () {
					if (isOpen) {
						item.classList.remove("is-open");
						return;
					}
					openItem(item);
				});
			};

			row.addEventListener("click", toggleItem);
			row.addEventListener("mouseenter", function () {
				if (!isHoverMode()) {
					return;
				}

				if (!item.classList.contains("is-open")) {
					openItem(item);
				}
			});
		});

		accordion.addEventListener("mouseleave", function () {
			if (!isHoverMode()) {
				return;
			}

			requestAnimationFrame(function () {
				items.forEach(function (item) {
					item.classList.remove("is-open");
				});
			});
		});
	});
});
